const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const BattleEventFactory = require('../../events/BattleEventFactory');
const HealEvent = require('../../events/HealEvent');
const { logError } = require('../../logger');

const HolyForce = function (battleState) {
  this.handle = 'holy_force';
  this.magic = true;
  this.help = true;
  this.harm = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return true;
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay) {
      return { success: false };
    }

    try {
      var ability = BattleCalc.getEquippedAbility(actor, this.handle);

      const getVictims = () => {
        var victims = [];
        var enemies = battleState.getEnemiesOfUnit(actor);

        for (var i = 0; i < enemies.length; ++i) {
          var enemy = enemies[i];
          if (
            enemy.inPlay &&
            BattleCalc.boardDistance(actor, enemy) <= ability.effectRange
          ) {
            victims.push(enemy);
          }
        }

        return victims;
      };

      var dist;
      var potency = ability.potency;
      var victims = getVictims();

      if (victims.length) {
        for (var i = 0; i < victims.length; ++i) {
          var uVictim = victims[i];
          dist = BattleCalc.boardDistance(actor, uVictim);
          // if( potency/dist < 1 ) continue;

          // if( checkForMagicMirror(_actor,uVictim) )
          // _eventFactory.makeKnockbackEvent( battleState.getTileUnderUnit(uVictim), _actor, Math.max(1,potency/dist) );
          // else

          // _eventFactory.makeKnockbackEvent( battleState.getTileUnderUnit(_actor), uVictim, Math.max(1,potency/dist) );
          BattleEventFactory.makeKnockbackEvent(
            battleState,
            battleState.getTileAtCoords(actor.x, actor.y),
            uVictim,
            potency / dist
          );
        }
      }

      for (var uid in battleState.allUnits) {
        var unit = battleState.allUnits[uid];

        if (
          unit.team === actor.team &&
          BattleCalc.boardDistance(actor, unit) <= 2
        ) {
          new HealEvent(battleState, actor, ability.healing).execute(unit);
        }
      }

      var result = { success: false };
      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      // result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'HolyForce',
        func: 'execute',
        actor,
        victim,
      });
      return { success: false };
    }
  };
};
module.exports = HolyForce;
